/**
 * @author lifei & gll
 * 模块说明：用户中心
 */

// 菜单
// export * as menu from './menu'
import { MenuService } from './menu'

// 登录
import { LoginService } from './login'

// 业务组管理
import { BusService } from './bus'

// 字典管理
import { DictService } from './dict'

// 组织模块
import { OrgService } from './org'

// 数据权限管理
import { PermissionConditionService } from './permissionCondition'

// 数据权限管理
import { CommodityApprovePerm } from './commodityApprovePerm'

// 岗位管理模块
import { PostService } from './post'

// 用户中心模块
import { RoleService } from './role'

// 用户管理模块
import { UserService } from './user'

// 分组模块
import { GroupService } from './group'

// 标签
import { TagService } from './tag'

// oss上传模块
import { OssService } from './oss'

// 业务关系管理
import { BusRelService } from './busRel'

//供应商用户
import { SupplierUserService } from './supplierUser'

export const login = new LoginService('/api/user/login')

export const tag = new TagService('/api/user/tag')

export const bus = new BusService('/api/user/bus')

export const org = new OrgService('/api/user/org')

export const dict = new DictService('/api/user/dict')

export const permissionCondition = new PermissionConditionService('/api/user/permissionCondition')

export const post = new PostService('/api/user/post')

export const menu = new MenuService('/api/user/menu')

export const role = new RoleService('/api/user/role')

export const user = new UserService('/api/user/user')

export const group = new GroupService('/api/user/group')

export const oss = new OssService('/api/user/oss')

export const busRel = new BusRelService('/api/user/busRel')

export const commodityApprovePerm = new CommodityApprovePerm('/api/user/commodityApprovePerm')

export const supplierUser = new SupplierUserService('/api/user/supplierUser')
